import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Nutrition, NutritionField, nutritionFields } from 'app/models/menu.model';

export function nutritionControlName(controlPrefix: string, field: NutritionField): string {
  return controlPrefix + field.charAt(0).toUpperCase() + field.slice(1);
}

@Component({
  selector: 'app-nutrition-form-field',
  templateUrl: './nutrition-form-field.component.html',
  styleUrls: ['./nutrition-form-field.component.scss']
})
export class NutritionFormFieldComponent {

  @Input() form: FormGroup;
  @Input() controlPrefix: string;
  @Input() originalNutrition: Nutrition | null;
  @Output() changed = new EventEmitter<void>();

  readonly fields = nutritionFields;

  getControlName(field: NutritionField): string {
    return nutritionControlName(this.controlPrefix, field);
  }

  getOriginalValue(field: NutritionField): number | null {
    return this.originalNutrition?.[field] ?? null;
  }

  isDifferent(field: NutritionField): boolean {
    return (this.form.value[this.getControlName(field)] ?? null) !== this.getOriginalValue(field);
  }

  restore(field: NutritionField) {
    this.form.patchValue({
      [this.getControlName(field)]: this.getOriginalValue(field),
    });
    this.changed.emit();
  }

  onInput() {
    this.changed.emit();
  }
}
